/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationManagementErrorResponseMessageMax = 200;

export const notificationManagementErrorResponseCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationManagementErrorResponseFieldErrorsItemPathMax = 120;

export const notificationManagementErrorResponseFieldErrorsMax = 20;

export const NotificationManagementErrorResponse = zod.object({
  code: zod.enum([
    'INVALID_REQUEST',
    'SESSION_REQUIRED',
    'CAPABILITY_DENIED',
    'NOT_FOUND',
    'VERSION_CONFLICT',
    'IDEMPOTENCY_CONFLICT',
    'REFERENCE_INACTIVE',
    'DEPENDENCY_UNAVAILABLE',
    'PAYLOAD_TOO_LARGE',
    'RATE_LIMITED',
    'STORAGE_UNAVAILABLE',
    'INTERNAL_ERROR',
  ]),
  message: zod.string().max(notificationManagementErrorResponseMessageMax),
  correlationId: zod.uuid().regex(notificationManagementErrorResponseCorrelationIdRegExp),
  fieldErrors: zod
    .array(
      zod.object({
        path: zod.string().max(notificationManagementErrorResponseFieldErrorsItemPathMax),
        reason: zod.enum(['INVALID_VALUE', 'OUT_OF_RANGE', 'DUPLICATE', 'UNSUPPORTED_FIELD']),
      }),
    )
    .max(notificationManagementErrorResponseFieldErrorsMax)
    .optional(),
});

export type NotificationManagementErrorResponse = zod.input<
  typeof NotificationManagementErrorResponse
>;
export type NotificationManagementErrorResponseOutput = zod.output<
  typeof NotificationManagementErrorResponse
>;
